module.exports = __webpack_public_path__ + "images/psp/PSPHero/drive-up-hero.webp";